// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.metaltile-container {
  padding: 0 50px 50px 50px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 45px;

  width: 100%;
}
.metaltile-header {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 45px;
  line-height: 54px;
  width: 100%;
  color: #6b3cb9;
  text-align: center;
}

.feature-tile-container {
  display: flex;
  justify-content: center;
}

.img-row {
  display: flex;
  background-color: #ffffff;
  justify-content: space-between;
  width: 80vw;
  justify-content: center;
  /* width: 100vw; */
}

.img-row img{
  max-width: 30vw;
}

.text-highlight {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 28px;
  line-height: 34px;

  color: #6b3cb9;

  text-align: center;
}

#bottom{
  gap: 5px;
}

@media (max-width: 415px) {
  
  .metaltile-header{
    font-size:34px;
  }

  .text-highlight{
    font-size: 1.5rem;
  }
  
  .img-row {
    flex-direction: column;
    align-items: center;
    justify-items: center;
    margin-top: 2rem;
    gap: 2rem;
  }

  .img-row img{
    max-width: 100%;
  }

  #bottom{
    gap: 2rem;
  }

  .metaltile-container{
    padding-top: 30px;
    gap: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/MetalTile.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;;EAEzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;;EAET,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,WAAW;EACX,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;;EAEjB,cAAc;;EAEd,kBAAkB;AACpB;;AAEA;EACE,QAAQ;AACV;;AAEA;;EAEE;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;AACF","sourcesContent":[".metaltile-container {\n  padding: 0 50px 50px 50px;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 45px;\n\n  width: 100%;\n}\n.metaltile-header {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 45px;\n  line-height: 54px;\n  width: 100%;\n  color: #6b3cb9;\n  text-align: center;\n}\n\n.feature-tile-container {\n  display: flex;\n  justify-content: center;\n}\n\n.img-row {\n  display: flex;\n  background-color: #ffffff;\n  justify-content: space-between;\n  width: 80vw;\n  justify-content: center;\n  /* width: 100vw; */\n}\n\n.img-row img{\n  max-width: 30vw;\n}\n\n.text-highlight {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 28px;\n  line-height: 34px;\n\n  color: #6b3cb9;\n\n  text-align: center;\n}\n\n#bottom{\n  gap: 5px;\n}\n\n@media (max-width: 415px) {\n  \n  .metaltile-header{\n    font-size:34px;\n  }\n\n  .text-highlight{\n    font-size: 1.5rem;\n  }\n  \n  .img-row {\n    flex-direction: column;\n    align-items: center;\n    justify-items: center;\n    margin-top: 2rem;\n    gap: 2rem;\n  }\n\n  .img-row img{\n    max-width: 100%;\n  }\n\n  #bottom{\n    gap: 2rem;\n  }\n\n  .metaltile-container{\n    padding-top: 30px;\n    gap: 30px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
